/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const inputs = feature.getInputs();
    const ID = feature.getID();
    const METHOD = feature.getSettingValue('METHOD');
    const INTERFACE = 'current_interface';
    const URL = `${feature.getSettingValue('URL')}`;
    const HEADERS = feature.getSettingValue('HEADERS');
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    let links = project.getNodeLinks(feature, 'http_request_start');
    const urlVariableName = `http_request_url_${feature.getID()}`;


    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
let ${urlVariableName} = "";
        `,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        id: 'def http_request',
        blockType: BlockType.CODE,
        template: `
async function http_request(method, url, data_payload = null, headers = null, ssl_cert = null) {
    try {
        let json_payload = null;
        if (headers && headers['Content-Type'] === 'application/json') {
            json_payload = JSON.parse(data_payload);
            data_payload = null;
        }
        
        const response = await fetch(url, {
            method,
            headers,
            body: data_payload ? data_payload : json_payload ? JSON.stringify(json_payload) : null
        });
        
        if (!response.ok) {
            throw new Error('HTTP error: ' + response.status);
        }
        
        const data = await response.text();
        /****callback_http_content_arrival****/
        /****callback_http_request_completed****/
    } catch (error_message) {
        error_message = error_message.toString();
        /****callback_http_request_failed****/
    }
}
        `,
    });

    const headers: { [key: string]: string } = {};
    for (let i = 0, len = HEADERS.length; i < len; i += 1) {
        const header = HEADERS[i];
        headers[header.getSettingValue('NAME')] = header.getSettingValue('VALUE');
    }

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        const source = project.getFeature(links[0].getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(links[0].getSettingValue('SOURCE_PORT'))?.params;
        const data = project.getNodeParameter(link, 'data');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
${urlVariableName} = ${project.parseCodeExpression(URL, sourceParams, TibboDataType.STRING)}
http_request('${METHOD.replace('HTTP_', '')}', ${urlVariableName}, ${data}, ${JSON.stringify(headers)})`,
        });
    }

    links = project.getNodeLinks(feature, 'http_data_arrival');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_content_arrival',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
console.log(${urlVariableName});
if (url === ${urlVariableName}) {
    /****${link.getSourceId()}****/
}
`,
        });
    }

    links = project.getNodeLinks(feature, 'http_complete');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_request_completed',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
if (url === ${urlVariableName}) {
    /****${link.getSourceId()}****/
}`,
        });
    }

    links = project.getNodeLinks(feature, 'http_error');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_request_failed',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
if (url === ${urlVariableName}) {
    /****${link.getSourceId()}****/
}`,
        });
    }

    return blocks;
};
